export default class PrimaryMenu {
  /**
  ** 実行
  ** @constructor
  **/    
  constructor(){
    this.getParam()
    this.init()
  }

  /**
  ** 各種要素を取得している
  ** @getParam
  **/  
  getParam () {
    this.Open = document.querySelector(`[data-module='menu-toggle']`)
    this.Close = document.querySelector(`[data-module='menu-close']`)
    this.Menu = document.querySelector(`[data-module='menu-content']`)
    this.Body = document.getElementsByTagName('body')[0]
    this.ToggleClass = 'is-show'
    this.LockClass = 'is-lock'
  }

  /**
  ** オブジェクトを初期化
  ** @init
  **/    
  init () {
    this.openToggle()
    this.closeToggle()
  }


  /**
 ** ボタンクリックでメニューを開くオブジェクト
 ** @openToggle
 **/  
  openToggle () {
    if(this.Open) {
      this.Open.addEventListener('click', () => {
        this.Menu.classList.add(this.ToggleClass)
        this.Body.classList.add(this.LockClass)
      })
    }
  }

  /**
 ** メニューを閉じるオブジェクト
 ** @closeToggle
 **/
  closeToggle () {
    if(this.Close) {
      this.Close.addEventListener('click', () => {
        this.Menu.classList.remove(this.ToggleClass)
        this.Body.classList.remove(this.LockClass)
      })      
    }

  }
}